import { useState } from 'react';
import { Loader2, Check, Trash2, KeyRound } from 'lucide-react';
import { useAiKey, useSetAiKey, useDeleteAiKey } from '../../hooks/useAiKeys';

// TAB Chiave AI (BYOK): mostra key_hint, imposta chiave OpenAI del cliente, rimuovi
export function AiKeyTab() {
  const { data, isLoading } = useAiKey();
  const setKey = useSetAiKey();
  const deleteKey = useDeleteAiKey();
  const [value, setValue] = useState('');

  // Normalizza l'hint: l'API può ritornare { key_hint } o { keys:[{provider,key_hint}] }
  const hint =
    data?.key_hint ?? data?.keys?.find((k) => k.provider === 'openai')?.key_hint ?? null;
  const hasKey = !!hint;

  async function save() {
    if (!value.trim()) return;
    await setKey.mutateAsync({ provider: 'openai', key: value.trim() });
    setValue('');
  }

  return (
    <div className="space-y-5">
      <div>
        <h3 className="text-sm font-semibold text-zinc-100">Chiave AI (OpenAI)</h3>
        <p className="mt-1 max-w-lg text-[11px] leading-relaxed text-zinc-500">
          Puoi usare la <strong className="text-zinc-400">tua chiave OpenAI</strong> (BYOK): i
          consumi AI verranno addebitati sul tuo account OpenAI. Se non imposti nessuna chiave, il
          sistema usa automaticamente la chiave Netlab inclusa nel tuo piano.
        </p>
      </div>

      {isLoading ? (
        <div className="flex justify-center py-6">
          <Loader2 size={16} className="animate-spin text-zinc-600" />
        </div>
      ) : (
        <>
          {hasKey && (
            <div className="flex items-center justify-between rounded-md border border-emerald-500/25 bg-emerald-500/10 px-3 py-2">
              <div className="flex items-center gap-2 text-xs text-emerald-300">
                <KeyRound size={13} />
                Chiave configurata: <span className="font-mono">{hint}</span>
              </div>
              <button
                onClick={() => deleteKey.mutate('openai')}
                disabled={deleteKey.isPending}
                className="flex items-center gap-1 rounded-md border border-zinc-700 px-2 py-1 text-[11px] text-zinc-300 transition hover:bg-zinc-800 disabled:opacity-40"
              >
                {deleteKey.isPending ? (
                  <Loader2 size={11} className="animate-spin" />
                ) : (
                  <Trash2 size={11} />
                )}
                Rimuovi
              </button>
            </div>
          )}

          <div>
            <label className="mb-1 block text-[10px] font-medium uppercase tracking-wider text-zinc-500">
              {hasKey ? 'Sostituisci chiave' : 'Imposta chiave OpenAI'}
            </label>
            <div className="flex items-center gap-2">
              <input
                type="password"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder="sk-..."
                className="flex-1 rounded-md border border-zinc-800 bg-zinc-950/60 px-2.5 py-1.5 font-mono text-sm outline-none focus:border-accent-500/50"
              />
              <button
                onClick={save}
                disabled={setKey.isPending || !value.trim()}
                className="flex items-center gap-1.5 rounded-md bg-accent-500 px-3 py-1.5 text-xs font-medium text-white transition hover:bg-accent-600 disabled:opacity-40"
              >
                {setKey.isPending ? (
                  <Loader2 size={12} className="animate-spin" />
                ) : (
                  <Check size={12} />
                )}
                Salva
              </button>
            </div>
            {setKey.isError && (
              <p className="mt-1.5 text-[11px] text-rose-400">
                Errore nel salvataggio della chiave.
              </p>
            )}
          </div>
        </>
      )}
    </div>
  );
}
